var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-swatches',{staticClass:"ml-4",attrs:{"show-fallback":"","fallback-input-type":"color","popover-x":"left","swatch-style":{ borderRadius: '4px' },"trigger-style":{
    width: '32px',
    height: '32px',
    borderRadius: '4px'
  },"value":_vm.value},on:{"input":_vm.changeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }